import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserLocationAction } from "./userLocationAction";

interface IUserLocationState {
  location: { lng: number; lat: number; placeId: string } | null;
}

const initialState: IUserLocationState = {
  location: UserLocationAction.getUserLocationFromLocal(),
};

const userLocationSlice = createSlice({
  name: "userLocation",
  initialState,
  reducers: {
    changeLocation: (
      state,
      action: PayloadAction<{ lng: number; lat: number; placeId: string }>
    ) => {
      state.location = action.payload;
    },
    setLocationToInitial: (state) => {
      state.location = UserLocationAction.getUserLocationFromLocal();
    },
  },
});

export const { changeLocation, setLocationToInitial } = userLocationSlice.actions;

export default userLocationSlice.reducer;
